import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52976aba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "com-upload" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "四川大厦的地图上传功能", -1))
const _hoisted_3 = { class: "file-upload" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-upload-text" }, "上传文件", -1))
const _hoisted_5 = { class: "fileName" }
const _hoisted_6 = { class: "status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("input", {
        class: "file-upload-input",
        id: "upfile",
        type: "file",
        webkitdirectory: "",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getFile && _ctx.getFile(...args)))
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.fileName), 1),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.status), 1)
  ]))
}